import { LayerKind } from "./layerKind";

/**
 * Разделы каталога. Каждый LayerKind получает диапазон из 1000 значений, а остаток
 * от деления на 1000 — номер подтипа внутри слоя.
 * Поэтому раздел однозначно определяет тип в каталоге и при этом знает свой слой чертежа.
 */
export enum CatalogSectionKind {
	Floor = LayerKind.Floors * 1000,
	Waterproof = LayerKind.Waterproof * 1000,
	Wall = LayerKind.Walls * 1000,
	Door = LayerKind.Walls * 1000 + 1,
	Window = LayerKind.Walls * 1000 + 2,
	Ceiling = LayerKind.Ceiling * 1000,
	Cable = LayerKind.Wiring * 1000,
	Electrical = LayerKind.Electrical * 1000,
	Lighting = LayerKind.Electrical * 1000 + 1,
	Plumbing = LayerKind.Plumbing * 1000,
	Water = LayerKind.Plumbing * 1000 + 1,
	Furniture = LayerKind.Furniture * 1000,
	Decor = LayerKind.Furniture * 1000 + 1,
	/** Мебель, собранная пользователем в конструкторе («Моя мебель») */
	CustomFurniture = LayerKind.Furniture * 1000 + 2,
	Screed = LayerKind.Screed * 1000,
	Pipe = LayerKind.Pipes * 1000,
	Finish = LayerKind.WallFinish * 1000,
	Baseboard = LayerKind.Baseboard * 1000,
}

/** @deprecated Используй CatalogSectionKind. */
export type CatalogSectionKey = CatalogSectionKind;

/** Слой чертежа, которому принадлежит раздел каталога. */
export const layerKindOfCatalogSection = (section: CatalogSectionKind): LayerKind =>
	Math.floor(section / 1000);

/** Проверяет, обслуживает ли раздел каталога указанный слой чертежа. */
export const catalogSectionUsesLayer = (section: CatalogSectionKind, layer: LayerKind): boolean =>
	layerKindOfCatalogSection(section) === layer;
